<style lang="scss">
  @import "../../admin/layout/admin";
</style>
<template>
  <el-container>
    <admin-header></admin-header>
    <el-container>
        <div class="m-userAction">
          <div class="panel-name">
            <span>自助制图看板</span>
            <el-checkbox @change="toggleAdmin" v-model="includeSysAdmin" class="m-l-20">管理员</el-checkbox>
          </div>
          <div class="statistic-container">
            <div class="sub-title">整体数据</div>
            <div class="box">
              <div class="title">累计用户数</div>
              <div class="number">{{avgTimeAndPv.userCount}}</div>
            </div>
            <div class="box">
              <div class="title">个人平均使用时长</div>
              <div class="number">{{avgTimeAndPv.userAvgTime}}</div>
              <div class="detail">模板库:{{avgTimeAndPv.templateAvgTime}} 作品库:{{avgTimeAndPv.workAvgTime}}
                编辑页:{{avgTimeAndPv.editAvgTime}} 素材库:{{avgTimeAndPv.materialAvgTime}}
              </div>
            </div>
            <div class="box">
              <div class="title">项目平均使用时长</div>
              <div class="number">{{avgTimeAndPv.projectAvgTime}}</div>
            </div>
            <div class="box">
              <div class="title">模板库/作品库/编辑页/素材库 PV</div>
              <div class="number">
                {{avgTimeAndPv.templatePv}}/{{avgTimeAndPv.workPv}}/{{avgTimeAndPv.editPv}}/{{avgTimeAndPv.materialPv}}
              </div>
            </div>
            <div class="sub-title">
              <span>banner数据</span>
              <a class="m-l-20" @click="showStatisticDataDialog('SINGLE')">统计管理</a>
            </div>
            <div class="box">
              <div class="title">单图编辑页人均使用时长</div>
              <div class="number">{{bannerStatus.editAvgTime}}</div>
            </div>
            <div class="box">
              <div class="title">单图编辑页PV</div>
              <div class="number">{{bannerStatus.editPv}}</div>
            </div>
            <div class="box">
              <div class="title">
                <span>单图保存作品/导出</span>
                <a @click="showQueryDialog('SINGLE')" class="f-r">查询</a>
              </div>
              <div class="number">{{bannerStatus.workSave}}/{{bannerStatus.workExport}}</div>
            </div>
            <br/>
            <div class="box">
              <div class="title">单图配置页人均使用时长</div>
              <div class="number">{{bannerStatus.configAvgTime}}</div>
            </div>
            <div class="box">
              <div class="title">单图配置页pv</div>
              <div class="number">{{bannerStatus.configPv || 0}}</div>
            </div>
            <div class="sub-title">
              <span>图文数据</span>
              <a class="m-l-20" @click="showStatisticDataDialog('MULTIPLE')">统计管理</a>
            </div>
            <div class="box">
              <div class="title">图文编辑页人均使用时长</div>
              <div class="number">{{multiStatus.editAvgTime}}</div>
            </div>
            <div class="box">
              <div class="title">图文编辑页pv</div>
              <div class="number">{{multiStatus.editPv}}</div>
            </div>
            <div class="box">
              <div class="title">
                <span>图文保存作品/导出</span>
                <a @click="showQueryDialog('MULTIPLE')" class="f-r">查询</a>
              </div>
              <div class="number">{{multiStatus.workSave}}/{{multiStatus.workExport}}</div>
            </div>
            <br/>
            <div class="box">
              <div class="title">图文配置页人均使用时长</div>
              <div class="number">{{multiStatus.configAvgTime}}</div>
            </div>
            <div class="box">
              <div class="title">图文配置页pv</div>
              <div class="number">{{multiStatus.configPv || 0}}</div>
            </div>
            <div class="sub-title">
              <span>PPT数据</span>
              <a class="m-l-20" @click="showStatisticDataDialog('PPT')">统计管理</a>
            </div>
            <div class="box">
              <div class="title">PPT编辑页人均使用时长</div>
              <div class="number">{{pptStatus.editAvgTime}}</div>
            </div>
            <div class="box">
              <div class="title">PPT编辑页pv</div>
              <div class="number">{{pptStatus.editPv}}</div>
            </div>
            <div class="box">
              <div class="title">
                <span>PPT保存作品/导出</span>
                <a @click="showQueryDialog('PPT')" class="f-r">查询</a>
              </div>
              <div class="number">{{pptStatus.workSave}}/{{pptStatus.workExport}}</div>
            </div>
            <br/>
            <div class="box">
              <div class="title">PPT配置页人均使用时长</div>
              <div class="number">{{pptStatus.configAvgTime}}</div>
            </div>
            <div class="box">
              <div class="title">PPT配置页pv</div>
              <div class="number">{{pptStatus.configPv || 0}}</div>
            </div>
          </div>
          <div class="chart-container">
            <div class="box">
              <div class="info">环比：{{avgRatio}}</div>
              <div class="title">平均使用时长</div>
              <div class="chart" id="average-time"></div>
              <i @click="averageTimeGo(-1)" class="icon el-icon-arrow-left"></i>
              <i @click="averageTimeGo(1)" class="icon el-icon-arrow-right"></i>
            </div>
            <div class="box">
              <div class="info">
                <span>环比：{{pavgRatio}}</span>
                <a @click="showProjectArerageTimeDialog" class="m-l-20">查看详情</a>
              </div>
              <div class="title">项目平均使用时长</div>
              <div class="chart" id="project-arerage-time"></div>
            </div>
            <!-- 暂时隐藏全量用户操作 -->
            <!-- <div class="box">
                <div class="title">全量用户操作流程</div>
                <div class="chart" id="total-flow"></div>
            </div> -->
            <div class="box" style="width: 100%">
              <div class="title">昨日随机用户操作流程</div>
              <div class="chart" id="random-flow">
                <div class="item" v-for="(item, index) in randomFlow" :key="index">
                  <div class="userName">{{item.userName || '匿名用户'}}</div>
                  <el-steps :space="160" align-center>
                    <el-step v-for="(step, index1) in item.visits" :key="index1" :title="step.actionName"
                             :description="step.startTime"></el-step>
                  </el-steps>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-name">智能抠图看板</div>
          <div class="statistic-container">
            <div class="sub-title">单图</div>
            <div class="box">
              <div class="title">点击上传图片到导出的时长</div>
              <div class="number">{{cutoutStats.uploadToExport}}</div>
            </div>
            <div class="box">
              <div class="title">点击上传图片到保存到素材库的时长</div>
              <div class="number">{{cutoutStats.uploadToSave}}</div>
            </div>
            <div class="box">
              <div class="title">点击上传图片到进入抠图页面的时长</div>
              <div class="number">{{cutoutStats.uploadToPage}}</div>
            </div>
            <div class="box">
              <div class="title">抠图页PV/UV</div>
              <div class="number">{{cutoutStats.pv}}/{{cutoutStats.uv}}</div>
            </div>
          </div>
          <div class="statistic-container">
            <div class="sub-title">多图</div>
            <div class="box">
              <div class="title">点击上传图片到导出的时长</div>
              <div class="number">{{cutoutStats.batchUploadToExport}}</div>
            </div>
            <div class="box">
              <div class="title">点击上传图片到保存到素材库的时长</div>
              <div class="number">{{cutoutStats.batchUploadToSave}}</div>
            </div>
            <div class="box">
              <div class="title">点击上传图片到进入抠图页面的时长</div>
              <div class="number">{{cutoutStats.batchUploadToPage}}</div>
            </div>
            <div class="box">
              <div class="title">抠图页PV/UV</div>
              <div class="number">{{cutoutStats.batchPv}}/{{cutoutStats.batchUv}}</div>
            </div>
          </div>
          <div class="panel-name">详细埋点</div>
          <div class="data-container">
            <div class="opration">
              <label>时间</label>
              <el-select class="c-radiu-select" v-model="time" @change="getTableData">
                <el-option
                    v-for="(item, index) in timeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
              <label>页面</label>
              <el-select class="c-radiu-select" v-model="page" @change="getTableData">
                <el-option
                    v-for="(item, index) in pageOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
              <span class="c-search-box">
                  <el-input placeholder="输入名称搜索" v-model="name" @change="getTableData"></el-input>
                  <el-button type="primary" circle class="c-search-btn" @click="getTableData"><i
                      class="iconfont icon-search"></i></el-button>
              </span>
            </div>
            <el-table :data="tableData">
              <el-table-column
                  prop="pageName"
                  label="分类"
                  min-width="240">
              </el-table-column>
              <el-table-column
                  prop="actionName"
                  label="埋点名称"
                  min-width="650">
              </el-table-column>
              <el-table-column
                  prop="count"
                  label="数据"
                  sortable
                  :sort-method="compare"
                  min-width="230">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-dialog custom-class="data-statistic-dialog" :visible.sync="dataDialogVisible"
                   :title="dataDialogObj.title + '数据统计管理'">
          <div>
              <span v-for="item in statisticDataList" :key="item.id">
                <span @click="toggleSelectProject(item)" class="item" :class="{gray: !item.selected}">
                  <span>{{item.name}}</span>
                  <i class="el-icon-check" v-if="item.selected"></i>
                </span>
              </span>
          </div>
          <span slot="footer">
                    <el-button @click="dataDialogVisible = false">取消</el-button>
                    <el-button @click="setStatisticData">保存</el-button>
                  </span>
        </el-dialog>
        <el-dialog custom-class="query-dialog" width="620px" :visible.sync="queryDialogVisible" title="作品/导出数据查询">
          <div class="body">
            <div class="time">
              <span>时间</span>
              <el-select v-model="reqTime" @change="onTimeChange">
                <el-option value="YESTERDAY" label="昨天">昨天</el-option>
                <el-option value="LATEST_WEEK" label="7天">7天</el-option>
                <el-option value="LATEST_30_DAYS" label="30天">30天</el-option>
                <el-option value="" :label="'自定义'">
                  <span v-if="reqTime">自定义</span>
                  <el-date-picker
                      ref="datepicker"
                      v-show="!reqTime"
                      v-model="rangeTime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
                </el-option>
              </el-select>
            </div>
            <div class="name">
              <span>搜索项目名称</span>
              <el-input placeholder="全部" v-model="queryDialogObj.projectName" class="project-name"></el-input>
            </div>
            <div class="type">
              <span>查询类型</span>
              <el-select v-model="queryDialogObj.statType">
                <el-option value="" label="全部">全部</el-option>
                <el-option value="SAVE" label="保存">保存</el-option>
                <el-option value="EXPORT" label="导出">导出</el-option>
              </el-select>
            </div>
            <el-button @click="onWorkStatSearch">查询</el-button>
            <a @click="onExport">导出excel</a>
          </div>
          <el-table :data="workStatList" :row-class-name="tableRowClassName">
            <el-table-column label="项目名称" prop="" min-width="300">
              <template slot-scope="scope">
                <div>
                  {{scope.row.projectName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="下载量" prop="amount" min-width="80">
              <template slot-scope="scope">
                <div>
                  {{scope.row.amount}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" prop="" min-width="80">
              <template slot-scope="scope">
                <a v-if="scope.$index > 0" @click="onShowProjectDetail(scope.row)">查看详情</a>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
        <el-dialog custom-class="project-arerage-dialog" title="项目平均使用时长"
                   :visible.sync="projectArerageTimeDialogVisible">
          <div id="project-arerage-time-big"></div>
        </el-dialog>
        <el-dialog destroy-on-close title=" " :visible.sync="projectDetailDialogVisible" width="700px"
                   custom-class="project-detail-dialog">
          <templateList v-model="projectDetailDialogVisible" :projectName="projectDetailObject.projectName"
                        :projectId="projectDetailObject.projectId"></templateList>
        </el-dialog>
    </el-container>
  </el-container>
</template>
<script>
    import adminHeader from '../../admin/layout/admin-header'
    import userDataService from '@/request/service/userData-service';
    import templateList from '@/views/admin/template//template-list'
    import util from '@/util.js';

    const common_attr = {
        editAvgTime: '0秒', editPv: 0, workSave: 0, workExport: 0, configAvgTime: '0秒',configPv: 0
    }
    export default {
        components: {adminHeader, templateList},
        data() {
            return {
                // defaultActive: this.$route.path,
                weekOffset: 0,
                dataDialogVisible: false,
                queryDialogVisible: false,
                projectDetailDialogVisible: false,
                projectArerageTimeDialogVisible: false,
                projectDetailObject: {
                    projectId: '',
                    projectName: '',
                },
                dataDialogObj: {
                    type: '',
                    title: '',
                },
                queryDialogObj: {
                    templateType: '',
                    projectName: '',
                    statType: 'EXPORT',
                },
                reqTime: 'LATEST_WEEK',
                rangeTime: '',
                workStatList: [],
                statisticDataList: [],
                includeSysAdmin: false,
                randomFlow: [],
                avgRatio: 0,
                pavgRatio: 0,
                avgTimeAndPv: {
                    userCount: null,
                    userAvgTime: null,
                    templateAvgTime: null,
                    workAvgTime: null,
                    editAvgTime: null,
                    materialAvgTime: null,
                    templatePv: null,
                    workPv: null,
                    editPv: null,
                    materialPv: null,
                    projectAvgTime: null,
                    editMultiAvgTime: null,
                    editMultiPv: null,
                },
                bannerStatus: Object.assign({}, common_attr),
                multiStatus: Object.assign({}, common_attr),
                pptStatus: Object.assign({}, common_attr),
                cutoutStats: {
                    uploadToExport: null,
                    uploadToSave: null,
                    uploadToPage: null,
                    pv: null,
                    uv: null,
                    batchPv: null,
                    batchUploadToExport: null,
                    batchUploadToPage: null,
                    batchUploadToSave: null,
                    batchUv: null
                },
                time: 'LATEST_WEEK',
                page: '',
                name: '',
                tableData: [],
                timeOptions: [{
                    value: 'YESTERDAY',
                    label: '昨日',
                }, {
                    value: 'LATEST_WEEK',
                    label: '最近7天',
                }, {
                    value: 'LATEST_30_DAYS',
                    label: '最近30天',
                }],
                pageOptions: [{
                    value: '',
                    label: '全部',
                }, {
                    value: 'home',
                    label: '首页',
                }, {
                    value: 'template',
                    label: '模板库',
                }, {
                    value: 'work_myWork',
                    label: '我的作品',
                }, {
                    value: 'work_teamWork',
                    label: '团队作品',
                }, {
                    value: 'material_img',
                    label: '图片素材',
                }, {
                    value: 'material_bg',
                    label: '背景素材',
                }, {
                    value: 'edit',
                    label: '编辑页',
                }, {
                    value: 'export_name',
                    label: '导出页面',
                }]
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.initChart();
                this.getStatisticData();
                this.getBannerStatus();
                this.getMultiStatus();
                this.getPPTStatus();
                this.getTableData();
                this.getRandomProcess();
                this.getCutoutStats();
            },
            compare(a, b) {
                return Number(a.count) - Number(b.count);
            },
            formatSecondToTime(second) {
                return util.formatSecondToTime(second);
            },
            toggleAdmin(value) {
                this.init();
            },
            showStatisticDataDialog(name) {
                if (name === 'SINGLE') {
                    this.dataDialogObj.title = 'banner';
                } else {
                    this.dataDialogObj.title = '图文';
                }
                this.dataDialogVisible = true;
                this.dataDialogObj.type = name;
                userDataService.getCustomCategory({
                    templateType: name
                }).then((result) => {
                    this.statisticDataList = result;
                }).catch((e) => {
                    // this.$message.error('');
                });
            },
            setStatisticData() {
                userDataService.setCustomCategory({
                    templateType: this.dataDialogObj.type,
                    projectIds: this.statisticDataList.filter(e => e.selected).map(e => e.id)
                }).then(() => {
                    this.dataDialogVisible = false;
                    if (this.dataDialogObj.type === 'SINGLE') {
                        this.getBannerStatus();
                    } else {
                        this.getMultiStatus();
                    }
                }).catch((e) => {
                    // this.$message.error(e.message);
                });
            },
            showQueryDialog(name) {
                this.queryDialogObj.templateType = name;
                this.queryDialogVisible = true;
                this.onWorkStatSearch();
            },
            onTimeChange(value) {
                if (!value) {
                    console.log(this.$refs.datepicker)
                    this.$refs.datepicker.handleFocus();
                }
            },
            onWorkStatSearch() {
                let params = {
                    excludeSysAdmin: !this.includeSysAdmin,
                }
                if (this.reqTime) {
                    params.reqTime = this.reqTime;
                } else {
                    params.startTimeFrom = this.rangeTime[0];
                    params.startTimeTo = this.rangeTime[1];
                }
                console.log(Object.assign({}, this.queryDialogObj, params));
                userDataService.getWorkStat(Object.assign({}, this.queryDialogObj, params)).then((result) => {
                    this.workStatList = result;
                    console.log()
                    this.workStatList.unshift({
                        projectName: '总计',
                        amount: result.reduce((a, b) => {
                            return {amount: Number(a.amount) + Number(b.amount)}
                        }, {amount: 0}).amount
                    });
                }).catch((e) => {
                    // this.$message.error(e.message);
                });
            },
            onShowProjectDetail(row) {
                this.projectDetailObject.projectId = row.projectId;
                this.projectDetailObject.projectName = row.projectName;
                this.projectDetailDialogVisible = true;
            },
            toggleSelectProject(item) {
                item.selected = !item.selected;
            },
            onExport() {
                let params = {
                    excludeSysAdmin: !this.includeSysAdmin,
                }
                if (this.reqTime) {
                    params.reqTime = this.reqTime;
                } else {
                    params.startTimeFrom = this.rangeTime[0];
                    params.startTimeTo = this.rangeTime[1];
                }
                userDataService.exportWorkStat(Object.assign({}, this.queryDialogObj, params)).then((result) => {
                    console.log(result);
                    util.download(result);
                });
            },
            showProjectArerageTimeDialog() {
                this.projectArerageTimeDialogVisible = true;
                userDataService.getAvgProjectTime({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    this.renderBigPAVGT(result.projectStats);
                    this.pavgRatio = result.ratio;
                }).catch(() => {
                    this.$message.error('获取项目平均使用时长出错');
                });
            },
            averageTimeGo(index) {
                if (this.weekOffset + index <= 0) {
                    this.weekOffset = this.weekOffset + index;
                    this.getAvgTimeChart();
                } else {
                    this.$message.info('已是最近数据');
                }
            },
            initChart() {
                this.getAvgTimeChart();
                this.getAvgProjectTimeChart();
                // this.renderTotalFlow();
            },
            getAvgTimeChart() {
                userDataService.getAvgTime({
                    excludeSysAdmin: !this.includeSysAdmin,
                    weekOffset: this.weekOffset
                }).then((result) => {
                    this.renderAVGT(result.userStats);
                    this.avgRatio = result.ratio;
                }).catch(() => {
                    this.$message.error('获取平均使用时长出错');
                });
            },
            getAvgProjectTimeChart() {
                userDataService.getAvgProjectTime({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    this.renderPAVGT(result.projectStats);
                    this.pavgRatio = result.ratio;
                }).catch(() => {
                    this.$message.error('获取项目平均使用时长出错');
                });
            },
            getStatisticData() {
                userDataService.getStatisticData({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    Object.assign(this.avgTimeAndPv, result);
                    for (let key in this.avgTimeAndPv) {
                        if (key.indexOf('AvgTime') > -1) {
                            this.avgTimeAndPv[key] = util.formatSecondToTime(this.avgTimeAndPv[key]);
                        }
                    }
                }).catch(() => {
                    this.$message.error('获取统计数据出错');
                });
            },
            getBannerStatus() {
                userDataService.getBannerStatisticData({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    this.bannerStatus = Object.assign({}, this.bannerStatus, result);
                    this.bannerStatus.editAvgTime = util.formatSecondToTime(result.editAvgTime);
                    this.bannerStatus.configAvgTime = util.formatSecondToTime(result.configAvgTime);
                }).catch(() => {
                    this.$message.error('获取banner数据出错');
                });
            },
            getMultiStatus() {
                userDataService.getMultiStatisticData({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    this.multiStatus = Object.assign({}, this.multiStatus, result);
                    this.multiStatus.editAvgTime = util.formatSecondToTime(result.editAvgTime);
                    this.multiStatus.configAvgTime = util.formatSecondToTime(result.configAvgTime);
                }).catch(() => {
                    this.$message.error('获取图文数据出错');
                });
            },
            getPPTStatus() {
                userDataService.getPPTStatisticData({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    this.pptStatus = Object.assign({}, this.pptStatus, result);
                    this.pptStatus.editAvgTime = util.formatSecondToTime(result.editAvgTime);
                    this.pptStatus.configAvgTime = util.formatSecondToTime(result.configAvgTime);
                }).catch(() => {
                    this.$message.error('获取PPT数据出错');
                });
            },
            getTableData() {
                let params = {
                    actionName: this.name,
                    time: this.time,
                    page: this.page,
                    excludeSysAdmin: !this.includeSysAdmin
                }
                userDataService.getTableData(params).then((result) => {
                    this.tableData = result;
                }).catch(() => {
                    this.$message.error('获取详细埋点操作流程出错');
                });
            },
            getRandomProcess() {
                userDataService.getRandomProcess({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    this.randomFlow = result;
                }).catch(() => {
                    this.$message.error('获取随机用户操作流程出错');
                });
            },
            getCutoutStats() {
                userDataService.getCutoutStats({
                    excludeSysAdmin: !this.includeSysAdmin
                }).then((result) => {
                    Object.assign(this.cutoutStats, result);
                    this.cutoutStats.uploadToExport = util.formatSecondToTime(result.uploadToExport);
                    this.cutoutStats.uploadToSave = util.formatSecondToTime(result.uploadToSave);
                    this.cutoutStats.uploadToPage = util.formatSecondToTime(result.uploadToPage);

                    this.cutoutStats.batchUploadToExport = util.formatSecondToTime(result.batchUploadToExport);
                    this.cutoutStats.batchUploadToSave = util.formatSecondToTime(result.batchUploadToSave);
                    this.cutoutStats.batchUploadToPage = util.formatSecondToTime(result.batchUploadToPage);
                });
            },
            renderChart(data, xAxis, myChart, options = {}) {
                let max = Math.ceil(Math.max(...data) / 60) * 60;
                let interval = Math.ceil(max / 60 / 4) * 60;
                max = interval * 4;
                var option = {
                    color: '#2E5BFF',
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params) {
                            let tar = params[0];
                            return util.formatSecondToTime(tar.value);
                        }
                    },
                    xAxis: {
                        data: xAxis,
                        axisLabel: options
                    },
                    yAxis: {
                        interval: interval,
                        max: max,
                        min: 0,
                        axisLabel: {
                            formatter: function (params) {
                                return (Math.floor(params / 60) + '分');
                            },
                        }
                    },
                    grid: {
                        left: 80,
                        bottom: 80
                    },
                    series: [{
                        name: '平均使用时长',
                        type: 'bar',
                        barWidth: '30%',
                        data: data
                    }]
                };
                myChart.setOption(option);
            },
            renderAVGT(result) {
                let data = [];
                let xAxis = [];
                result.forEach((item) => {
                    data.push(item.avgDuration);
                    xAxis.push(item.date);
                });
                var myChart = echarts.init(document.getElementById('average-time'));
                this.renderChart(data, xAxis, myChart);
            },
            renderPAVGT(result) {
                let data = [];
                let xAxis = [];
                result.forEach((item) => {
                    xAxis.push(item.projectName);
                    data.push(item.duration);
                });
                var myChart = echarts.init(document.getElementById('project-arerage-time'));
                this.renderChart(data, xAxis, myChart, {interval: 0, rotate: 30});
            },
            renderBigPAVGT(result) {
                let data = [];
                let xAxis = [];
                result.forEach((item) => {
                    xAxis.push(item.projectName);
                    data.push(item.duration);
                });
                var myChart = echarts.init(document.getElementById('project-arerage-time-big'));
                this.renderChart(data, xAxis, myChart, {interval: 0, rotate: 30});
            },
            renderTotalFlow() {
                let data = [100, 80, 80, 70, 60, 60, 60];
                let xAxis = ["模板页", "预览模板", "选择模板", "编辑", "编辑文字", "导出", '完成'];
                var myChart = echarts.init(document.getElementById('total-flow'));
                var option = {
                    color: '#2E5BFF',
                    tooltip: {
                        formatter: function (params) {
                            if (params.dataIndex === 0) {
                                return 100 + '%';
                            } else {
                                return data[params.dataIndex] / data[params.dataIndex - 1] * 100 + '%';
                            }
                        }
                    },
                    xAxis: {
                        data: xAxis
                    },
                    grid: {
                        left: 80,
                    },
                    yAxis: {},
                    series: [{
                        name: '全量用户操作流程',
                        type: 'bar',
                        barWidth: '30%',
                        data: data
                    }]
                };
                myChart.setOption(option);
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                    return 'summary'
                }
            }
        }
    }
</script>